import React from 'react';
import './Testimonials.css';

const testimonials = [
  {
    name: 'Ravi Kumar',
    route: 'Patna \u2192 Gaya \u00B7 One-Way Taxi',
    quote: 'Patna se Gaya ek taraf ka kiraya dena pada \u2014 pehli baar itna sasta mila. Driver time pe tha, gaadi saaf thi. ZilaCab recommend karunga.',
    initials: 'RK',
    color: '#E8590A',
  },
  {
    name: 'Sunita Prasad',
    route: 'Shaadi \u00B7 Muzaffarpur \u00B7 Wedding Fleet',
    quote: 'Shaadi ke liye 8 gaadiyaan book ki, sab decorated thi, sab time pe aayi. Muzaffarpur mein is rate pe koi nahi deta. Bahut khush hoon.',
    initials: 'SP',
    color: '#1A7A4A',
  },
  {
    name: 'Anil Mehta',
    route: 'Ghar Shifting \u00B7 Patna \u00B7 House Shifting',
    quote: 'Ghar shifting ke liye sab kuch safe raha. Packing bhi theek se ki, koi cheez nahi tuti. GPS tracking se track karta raha poora din.',
    initials: 'AM',
    color: '#1A4A7A',
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials">
      <div className="testimonials__container">
        <span className="testimonials__eyebrow">Happy customers</span>
        <h2 className="testimonials__heading">Bihar kehta hai</h2>
        <p className="testimonials__sub">
          Asli log. Asli safar. We only show verified customer reviews.
        </p>

        <div className="testimonials__grid">
          {testimonials.map((t, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-card__stars">
                &#9733;&#9733;&#9733;&#9733;&#9733;
              </div>
              <p className="testimonial-card__quote">&ldquo;{t.quote}&rdquo;</p>
              <div className="testimonial-card__author">
                <div
                  className="testimonial-card__avatar"
                  style={{ backgroundColor: t.color }}
                >
                  {t.initials}
                </div>
                <div className="testimonial-card__info">
                  <span className="testimonial-card__name">{t.name}</span>
                  <span className="testimonial-card__route">{t.route}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
